<template>
  <div>
    <h1>this page is protected by auth</h1>
  </div>
</template>

<script>
export default {

  name: 'Secure',

  data() {
    return {

    };
  },
};
</script>

<style lang="css" scoped>
</style>
